import {
  Component,
  OnInit,
  OnDestroy,
  ViewContainerRef,
  Input,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import {
  map,
  first,
  startWith,
  distinctUntilChanged,
  takeUntil,
} from 'rxjs/operators';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import 'moment/locale/it';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../services/utils.service';
import { AlgConditionModalComponent } from '../../components/dialogs/alg-condition-modal/alg-condition-modal.component';

import {
  AlgConsensoService,
  REQUEST_STATUS_INVALID,
  REQUEST_STATUS_OK,
} from '../../services/alg-consenso.service';
import {
  ApprovalFeedback,
  ApprovalAgileRequest,
} from '../../services/alg-consenso.service.d';
import { LocationStrategy } from '@angular/common';
@Component({
  selector: 'alg-consent-agile-request',
  templateUrl: './alg-consent-agile-request.html',
  styleUrls: ['./alg-consent-agile-request.scss'],
})
export class AlgConsensoAgileRequestComponent implements OnInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  public operatorRating$: Observable<ApprovalFeedback>;
  public agileRequest$: Observable<any>;
  public isConsentsOk: boolean;
  public feedbackOptions = [
    { image: 'bad', value: 100 },
    { image: 'normal', value: 200 },
    { image: 'good', value: 300 },
    { image: 'excellent', value: 400 },
  ];
  public feedbackModalContent = {
    title: 'La tua privacy per noi è importante.',
    description: '',
  };
  public product: any;
  public isLight: boolean;
  public isGas: boolean;

  public goNextStep: boolean;

  public idRichiesta: string;
  public typeRichiesta: string;
  public codeRichiesta: string;
  public temporaryUrl: string;
  public clientPod: string;
  public clientPdr: string;
  public clientPremio: string;
  public premioBuono: boolean;
  public premioSconto: boolean;
  public clientPremioDetail: string;
  public email: string;
  public clientNameSF: string;
  public clientCF: string;
  public energiaVerde: boolean;
  public checkBoxGreen = false;
  public invalidGreenCondition: boolean;
  public isDual: boolean;
  public infoContractData: {
    title: string;
  };

  public consentsWithAdditionalProperty: any;
  public isOtpChecked: boolean;
  public invalidGeneralCondition = {
    consents: false,
    clause: false,
  };
  public cteLink: string;
  public cgfLink: string;

  private clientId$: Observable<any>;
  private phone_number = '';
  private ngUnsubscribe = new Subject<void>();
  private contractTypeCTE: string;
  private contractTypeCGF: string;

  // OBSERVABLE TO WATCH REQUEST STATUS
  public isRequestOk$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;

  private _id: string;
  public checkboxGeneralCondition = {
    checkboxConsents: false,
  };

  // TEXT PART
  public textField = {
    label1:
      'Il Cliente sottoscrivendo per adesione la presente proposta accetta che in relazione alla fornitura di ',
    label2:
      'a lui intestata verrà applicata la nuova Tipologia Offerta: Accendi Casa Agile',
    label3:
      'con riferimento CTE: Dicembre 2021 la cui data di decorrenza nuova offerta sarà il 01/01/2022.',
    label4:
      'Con la sottoscrizione per adesione alla presente proposta, che avverrà tramite firma elettronica semplice (FES), il Cliente:',
    label5:
      "accetta la modifica della Tipologia offerta in relazione alla/e fornitura/e sopra indicata/e nei termini e condizioni della presente Proposta di Cambio Piano e che l'Allegato B Condizioni Tecniche Economiche per la fornitura di ",
    label6: 'qui disponibile sostituisca quello precedentemente in vigore;',
    label7:
      "dichiara di conoscere e accettare le ulteriori condizioni contrattuali, costituite dalla Proposta di cambio Piano e dai relativi Allegati (oltre all'Allegato B- Condizioni Tecniche Economiche sopra nominato anche l’Allegato A - Condizioni Generali per la fornitura qui disponibile, che ne formano parte integrante e sostanziale;",
    label8:
      "accetta che, in relazione alla fornitura di energia elettrica, qualora l'opzione 100% Verde Energie Rinnovabili fosse già attiva nell'offerta precedente tale opzione continui ad essere applicata oppure se il prodotto precedente fosse \"Accendi Ecologica\" sia applicata l'opzione 100% Verde Energie Rinnovabili. Il costo aggiuntivo di tale opzione è pari a 0,005 Euro/kWh per l'energia fornita.",
    label9:
      "Per tutto quanto non modificato con la presente, restano validi i consensi e le ulteriori informazioni fornite all'interno del modulo di Adesione alla Proposta di fornitura in fase di sottoscrizione iniziale del contratto, o come modificate in vigenza di contratto. ",
    label10:
      'Puoi prendere visione di tutti i dettagli nell’Allegato B - Condizioni tecniche economiche (CTE) e nell’Allegato A - Condizioni generali di fornitura',
    label11:
      'e puoi chiamare il servizio clienti in qualsiasi momento per disattivare l’opzione.',
    label12:
      'Ricorda che potrai esercitare il diritto di ripensamento in forma scritta entro 14 giorni dalla sottoscrizione mediante accettazione della presente adesione.',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    public locations: LocationStrategy
  ) {
    this.clientId$ = this.activatedRoute.params.pipe(
      map((params) => params && params.id)
    );
    this.isLoading$ = this.consensoService.isLoading$;
    this.operatorRating$ = this.consensoService.operatorRatingCode$.pipe(
      first((rating) => !!rating)
    );
  }

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.temporaryUrl = window.location.href;
      this.idRichiesta = params.id;
      this.codeRichiesta = params.codice;
      this.typeRichiesta = params.tipo;
      this.clientPod = params.pod || '';
      this.clientPdr = params.pdr || '';
      this.clientPremio = params.premio || '';
      this.email = params.email;
      this.isLight =
        this.temporaryUrl.includes('mono-luce') ||
        this.temporaryUrl.includes('dual');
      this.isGas =
        this.temporaryUrl.includes('mono-gas') ||
        this.temporaryUrl.includes('dual');
      this.isDual = this.isGas && this.isLight;
      if (this.clientPremio === 'buono') {
        this.premioBuono = !this.premioBuono;
        this.clientPremioDetail = 'BuonoAgile';
      }
      if (this.clientPremio === 'sconto') {
        this.premioSconto = !this.premioSconto;
        this.clientPremioDetail = 'ScontoAgile';
      }
    });

    this.consensoService.fetchAgileRequest(this.idRichiesta);

    this.consensoService.agileRequest$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((request) => {
        // NOTE: Request sometimes is the object from Salesforce, sometimes an object from keystone
        // We need to support both input data by providing two different request attribute namings
        this.clientNameSF = request.Name || request.clientName;
        this.clientCF = request.Codice_Fiscale__c || request.fiscalCode;
        this.phone_number = request.Phone || request.phone;
      });

    this.consensoService.isOtpAgileRequest$.subscribe((checked) => {
      this.isOtpChecked = checked;
    });

    this.isRequestOk$ = this.consensoService.agileRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_OK),
      startWith(false),
      distinctUntilChanged()
    );

    this.isErrorGeneric$ = this.consensoService.agileRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_INVALID),
      startWith(false),
      distinctUntilChanged()
    );

    const discountString =
      this.clientPremio === 'buono' ? 'BUONO12' : 'SCONTO12';
    this.convertContracTypeToString(this.typeRichiesta);
    this.cteLink = `https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/agile/122021_ALLB-CTE-CASAAGILE-${this.contractTypeCTE}-NA-${discountString}-ALG.pdf`;

    this.cgfLink = `https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/agile/CGF/General+Conditions+${this.contractTypeCGF}+-+ALG.pdf`;
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  public readCondition(type) {
    let modalContent;
    if (type === 'dataConsent') {
      modalContent = this.feedbackModalContent;
    }
    this.openModal(modalContent || {});
  }

  // feedback
  public onFeebackModal(event) {
    if (event === 'open') {
      this.readCondition('dataConsent');
    }
  }

  public openOTPmodal() {
    if (!this.goNextStep) {
      if (!this.checkboxGeneralCondition.checkboxConsents) {
        this.invalidGeneralCondition.consents = true;
        this.scrollOnInvalidElement('generalInvalid');
      }
      return;
    }
    this.utils.disableOverflow();
    if (this.goNextStep) {
      this.consentsWithAdditionalProperty = {
        accountId: `${this.idRichiesta}`,
        contractId: `${this.codeRichiesta}`,
        requestType: `${this.typeRichiesta}`,
        Alg_OTPCheck__c: false,
        Alg_OTPCheckDate__c: '',
        Alg_OTPPhone__c: '',
        phone: `${this.phone_number}`,
        discount: `${this.clientPremioDetail}`,
        clientName: `${this.clientNameSF}`,
        email: `${this.email}`,
        linkCTE: `${this.cteLink}`,
        linkCGF: `${this.cgfLink}`,
        fiscalCode: `${this.clientCF}`,
      };
      this.isConsentsOk = true;
      const htmlPage = document.getElementById('agileText').innerHTML;
      const textPage = document.getElementById('agileText').innerText;
      this.consensoService.saveAgileRequest(
        this.consentsWithAdditionalProperty
      );
      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Un ultimo passo: verifica il tuo numero di cellulare',
        childComponent: AlgOtpModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline textCenter',
        },
        data: {
          isConsentsOk: this.isConsentsOk,
          consents: this.consentsWithAdditionalProperty,
          phone: this.phone_number,
          linear: false,
          consensoType: 'agile_request',
          htmlPage,
          textPage,
        },
      });
    }
  }

  private scrollOnInvalidElement(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
    });
  }

  // Function to set valid OTP Verify button - General Condition Right Section
  getValidCheckboxesSecondPart(value) {
    this.checkboxGeneralCondition.checkboxConsents = value;
    if (value) {
      this.invalidGeneralCondition.consents = false;
    }

    if (this.checkboxGeneralCondition.checkboxConsents) {
      this.goNextStep = true;
    } else {
      this.goNextStep = false;
    }
  }

  convertContracTypeToString(contract: string) {
    switch (contract) {
      case 'mono-luce':
        this.contractTypeCTE = 'ee'.toUpperCase();
        this.contractTypeCGF = 'Mono+EE';
        break;
      case 'mono-gas':
        this.contractTypeCTE = 'gas'.toUpperCase();
        this.contractTypeCGF = 'Mono+Gas';
        break;
      case 'dual':
        this.contractTypeCTE = 'dual'.toUpperCase();
        this.contractTypeCGF = 'DUO';
        break;
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-consent-agile-request/alg-consent-agile-request.ts